import { FIELDWORKER_COLORS } from "~/config/statusColors";
import { ROUTE_LINE_COLOR_BY_TYPE } from "~/modules/plannerV2/components/map-layers/RoutesLayerV2";

export const LABEL_CONFIGS = {
    assigned: {
        color: FIELDWORKER_COLORS.assigned,
        textOffset: [0, 2] as [number, number],
        anchor: "top" as const,
    },
    available: {
        color: FIELDWORKER_COLORS.available,
        textOffset: [0, 2] as [number, number],
        anchor: "top" as const,
    },
    homeAddress: {
        color: ROUTE_LINE_COLOR_BY_TYPE.secondary,
        textOffset: [0, 1.5] as [number, number],
        anchor: "top" as const,
    },
} as const;

export type LabelColor = keyof typeof LABEL_CONFIGS;
